import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import withOptions from 'utils/functions/withOptions.util';
import actionType from 'utils/mw/actionType.util';

const ATAG = 'beGetTagsTrial';
const AT = actionType(ATAG);

const beGetTagsTrial = withOptions(({ salonId }) =>
  endpoint(H.get, 'salon/v2/:salonId/salon_features/promotion/', {
    AT,
    name: ATAG,
    params: { salonId },
  }),
);

beGetTagsTrial.AT = AT;
beGetTagsTrial.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beGetTagsTrial;
